import React, { useEffect, useState } from 'react'
import './style.css'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { unSubscribe } from 'Redux/reminder/reminder.actions'
import environment from 'environments/environment'
import { Typography } from '@material-ui/core'

export default function Unsubscribed() {

    let { id } = useParams()
    const dispatch = useDispatch()
    const { unSubscribeResponse } = useSelector(
        (state) => state.reminder,
      )

    useEffect(()=>{
        if(id){
          dispatch(unSubscribe(id))
        }
    },[id])

    const clinicName = unSubscribeResponse?.data?.clinicName
    const clinicPhone = unSubscribeResponse?.data?.clinicPhone
    const clinicEmail = unSubscribeResponse?.data?.clinicEmail


  return (
    <div className="unsub-page">
      <div className="unsub-layout">
        <div className="unsub-card">
          <div className="unsub-accent" />

          <h1 className="unsub-title">You Have Successfully Unsubscribed</h1>

          <p className="unsub-message">
            A confirmation email will be sent shortly with a Subscribe link you
            can use anytime to re-subscribe. If you ever decide you’d like to
            receive appointment reminders, virtual check-in, you can easily
            rejoin at any time.
          </p>

          <a href={`/subscribed/${id}`} className="unsub-btn">
            Resubscribe
          </a>

          <div className="unsub-divider" />

          <div className="unsub-contact">
            <h2 className="unsub-contact-title">Need Assistance?</h2>

            <div className="unsub-contact-box">
              <p className="unsub-contact-line unsub-contact-strong">
                <strong>{clinicName}</strong>
              </p>

              <p className="unsub-contact-line">
                Phone:{' '}
                <a href={`tel:${clinicPhone}`} className="unsub-link">
                  {clinicPhone}
                </a>
              </p>

              <p className="unsub-contact-line">
                Email:{' '}
                <a href={`mailto:${clinicEmail}`} className="unsub-link">
                  {clinicEmail}
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="unsub-footer">
          <Typography
            variant="caption"
            align="center"
            color="textSecondary"
            display="block"
          >
            © {new Date().getFullYear()}–{new Date().getFullYear() + 1}{' '}
            {environment.companyName}. All rights reserved.
            <div>
              {environment.copyRight}
              <br />
              Unauthorized access, use, or reproduction of this application or
              its contents is strictly prohibited.
            </div>
          </Typography>
        </div>
      </div>
    </div>
  )
}
